<ct-lib-modal
  [label]="'company-tool.snippets.tfa.add-modal.title' | transloco"
  [footer]="addMethodModalFooter"
  (onOpen)="onModalOpen()"
  (onCloseEnd)="onModalCloseEnd()"
  [small]="true"
  #addMethodModal
>
  @if (!qrLoaded) {
    <ct-lib-info-banner class="tfa-info">{{
      'company-tool.snippets.tfa.add-modal.info' | transloco
    }}</ct-lib-info-banner>
    <form [formGroup]="addMethodForm">
      <div class="row mt-3">
        <div
          class="col-12 form-group form-floating"
          [class.invalid]="addMethodFormSubmitAttempt && name.invalid"
        >
          <input
            type="text"
            formControlName="name"
            class="form-control"
            id="tfaName"
            [placeholder]="
              'company-tool.snippets.tfa.add-modal.form.name.placeholder'
                | transloco
            "
            (keyup.enter)="onContinue()"
          />
          <label for="tfaName">{{
            'company-tool.snippets.tfa.add-modal.form.name.placeholder'
              | transloco
          }}</label>
        </div>
      </div>
    </form>
  } @else {
    <form [formGroup]="addMethodForm">
      <div class="row">
        <div class="col-12 form-group form-floating">
          <input
            type="text"
            formControlName="name"
            class="form-control"
            id="tfaNameReadonly"
            readonly
            [placeholder]="
              'company-tool.snippets.tfa.add-modal.form.name.placeholder'
                | transloco
            "
          />
          <label for="tfaNameReadonly">{{
            'company-tool.snippets.tfa.add-modal.form.name.placeholder'
              | transloco
          }}</label>
        </div>
      </div>
    </form>
    <span
      [innerHTML]="
        'company-tool.snippets.tfa.add-modal.app-modal.qr-info' | transloco
      "
    ></span>
    <div class="qr-code-wrapper">
      <img [src]="tfaQRCodeImage" alt="" />
      <span>
        {{
          'company-tool.snippets.tfa.add-modal.app-modal.qr-manual' | transloco
        }}<br />
        <b>{{ tfaQRCode }}</b>
      </span>
    </div>
    <span
      [innerHTML]="
        'company-tool.snippets.tfa.add-modal.app-modal.code-info' | transloco
      "
    ></span>
    <div class="tfa-input-wrapper">
      <app-tfa-input
        [autoSubmit]="true"
        (submit)="onTFASubmit($event)"
        #tfaInput
      ></app-tfa-input>
    </div>
  }
</ct-lib-modal>
<ng-template #addMethodModalFooter>
  <app-button variant="white-grey" (click)="addMethodModal.close()">
    {{ 'company-tool.snippets.tfa.add-modal.footer.cancel' | transloco }}
  </app-button>
  @if (!qrLoaded) {
    <app-button [loading]="loadingQr" (click)="onContinue()">
      {{ 'company-tool.snippets.tfa.add-modal.footer.next' | transloco }}
    </app-button>
  }
</ng-template>
